import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const navigate = useNavigate();

  const handleSendLink = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/api/forgot-password`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ email }),
      });

      // Log the response status for debugging
      console.log('Response status:', response.status);
      
      // Try to parse the response
      let data;
      try {
        data = await response.json();
      } catch (parseError) {
        console.error('Failed to parse response:', parseError);
        toast.error("Server returned an invalid response");
        setLoading(false);
        return;
      }

      console.log('Response data:', data);

      if (response.ok) {
        toast.success(data.message || "New password sent to your email!");
        setEmailSent(true);
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        toast.error(data.error || data.message || "Failed to send new password");
      }
    } catch (err) {
      console.error('Fetch error:', err);
      toast.error("Failed to connect to server. Please check your network connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow p-4" style={{ width: '400px' }}>
        <h3 className="text-center mb-4">Forgot Password</h3>
        
        {emailSent ? (
          <div className="text-center">
            <div className="alert alert-success">
              <i className="bi bi-check-circle-fill me-2"></i>
              New password sent!
            </div>
            <p className="text-muted small">
              We've sent a new password to your email address. 
              Please check your inbox and spam folder.
            </p>
            <p className="text-muted small">
              <strong>Note:</strong> Please change your password after logging in.
            </p>
            <Link to="/login" className="btn btn-primary mt-3">
              Go to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSendLink}>
            <div className="mb-3">
              <label className="form-label">Email address</label>
              <input 
                type="email" 
                className="form-control" 
                placeholder="Enter your registered email" 
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              <small className="text-muted">
                We'll send a new password to this email.
              </small>
            </div>
            <button 
              type="submit" 
              className="btn btn-primary w-100" 
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Sending...
                </>
              ) : (
                'Send New Password'
              )}
            </button>
          </form>
        )}
        
        <div className="mt-3 text-center">
          <Link to="/login" className="text-decoration-none">
             Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;